import { useFormDataContext, usePrePopContext } from '../../../lib/contexts';
import React, {useEffect, useState} from 'react';
import CustomBackButton from '../../CustomComponents/CustomBackButton';
import { useScrollToTop } from '../../../lib/hooks';
import {isZipCodeValid} from "../../../lib/utils";

function FormStep13() {
    const { updateFormData, formData, updateStep } = useFormDataContext();
    const [ zipError, setZipError ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState("");
    const [ zip, setZip ] = useState("");
    const prePop = usePrePopContext();

    const handleChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 5) {
            setZip(value);
        }
    };

    useEffect(() => {
        setZip(formData.zip || prePop.zip || "");
      }, [formData.zip, prePop.zip]);

    const handleClick = async (e) => {
        e.preventDefault();
        const isValidZipCode = await isZipCodeValid(zip);
        const {city, state} = isValidZipCode;

        if (zip.length > 0 && zip.length < 5) {
            setZipError(true);
            setErrorMessage("ZIP code must have 5 digits");
        } else if (zip.trim() === "" || isValidZipCode.error !== '') {
            setZipError(true);
            setErrorMessage("Please enter a valid ZIP code");
        } else {
            setZipError(false);
            setErrorMessage("");

            updateFormData({
                step: formData.step + 1,
                zip: zip,
                city: city,
                state: state,
            });
        }
    }

    useScrollToTop();

    return (
        <>
            <div id="question13">
                <div className="input-wrap">
                    <label>Zip Code</label>
                    <input
                        name="zip"
                        onChange={handleChange}
                        value={zip}
                        placeholder="Please Enter Zip Code *"
                        required=""
                        className={`form-control text-grey ${zipError && 'form-control text-grey error'}`}
                        inputMode="numeric"
                        pattern="[0-9]*"
                    />
                    {errorMessage && <span className="error-message">{errorMessage}</span>}
                </div>
                <button onClick={handleClick} className="step-button">
                    Next
                </button>
                <CustomBackButton/>
            </div>
        </>
    );
}

export default FormStep13;
